exports.__esModule = true;
exports.default = void 0;

let React = /*#__PURE__*/ _interopRequireWildcard(
	/*#__PURE__*/ require('react')
);

let _event = /*#__PURE__*/ _interopRequireDefault(
	/*#__PURE__*/ require('@react-hook/event')
);

let _throttle = /*#__PURE__*/ require('@react-hook/throttle');

function _interopRequireDefault(obj) {
	return obj && obj.__esModule ? obj : { default: obj };
}

function _getRequireWildcardCache() {
	if (typeof WeakMap !== 'function') return null;
	let cache = new WeakMap();
	_getRequireWildcardCache = function () {
		return cache;
	};
	return cache;
}

function _interopRequireWildcard(obj) {
	if (obj && obj.__esModule) {
		return obj;
	}
	if (obj === null || (typeof obj !== 'object' && typeof obj !== 'function')) {
		return { default: obj };
	}
	let cache = _getRequireWildcardCache();
	if (cache && cache.has(obj)) {
		return cache.get(obj);
	}
	let newObj = {};
	let hasPropertyDescriptor =
		Object.defineProperty && Object.getOwnPropertyDescriptor;
	for (let key in obj) {
		if (Object.prototype.hasOwnProperty.call(obj, key)) {
			let desc = hasPropertyDescriptor
				? Object.getOwnPropertyDescriptor(obj, key)
				: null;
			if (desc && (desc.get || desc.set)) {
				Object.defineProperty(newObj, key, desc);
			}
			else {
				newObj[key] = obj[key];
			}
		}
	}
	newObj.default = obj;
	if (cache) {
		cache.set(obj, newObj);
	}
	return newObj;
}

function _ref(state, action) {
	const { event: e, element } = action;
	let event;

	if ('touches' in e) {
		event = e.touches[0];
	}
	else {
		event = e;
	}

	const { clientX, clientY, screenX, screenY, pageX = 0, pageY = 0 } = event;
	const rect = element.getBoundingClientRect();
	const x = pageX - rect.left - window.pageXOffset;
	const y = pageY - rect.top - window.pageYOffset; // shims a mouseleave event for touch devices

	if ('touches' in e && (x < 0 || y < 0 || x > rect.width || y > rect.height)) {
		return {
			...state,
			context: { ...state.context, hoverStatus: 'leave', touchStatus: 'end' }
		};
	}

	return {
		context: { ...state.context, hoverStatus: 'enter' },
		mouse: {
			...state.mouse,
			x,
			y,
			pageX,
			pageY,
			clientX,
			clientY,
			screenX,
			screenY,
			elementWidth: rect.width,
			elementHeight: rect.height,
			isOver: true,
			isTouch: 'touches' in e
		}
	};
}

function _ref2(state, action) {
	const { mouse, context } = state;
	const handleDown = _ref;

	if (action.type === 'mousemove') {
		// Bails out if touch has ended
		if (context.touchStatus === 'end') return state;
		return handleDown(state, action);
	}
	else if (action.type === 'touchmove') {
		const nextState = {
			context: { ...context, touchStatus: 'start' },
			mouse
		};
		return handleDown(nextState, action);
	}
	else if (action.type === 'touchdown') {
		const nextState = {
			context: { ...context, touchStatus: 'start' },
			mouse: { ...mouse, isDown: true }
		};
		return handleDown(nextState, action);
	}
	else if (action.type === 'mousedown') {
		return {
			context,
			mouse: { ...mouse, isDown: true }
		};
	}
	else if (action.type === 'mouseup') {
		return {
			context,
			mouse: { ...mouse, isDown: false }
		};
	}
	else if (action.type === 'mouseleave') {
		return {
			context: { ...context, hoverStatus: 'leave' },
			mouse: { ...mouse, isOver: false }
		};
	}
	else if (action.type === 'touchleave') {
		return {
			context: { ...context, hoverStatus: 'leave', touchStatus: 'end' },
			mouse: { ...mouse, isOver: false, isDown: false }
		};
	}
	else if (action.type === 'activeStatus') {
		return {
			context: { ...context, activeStatus: action.value },
			mouse
		};
	}

	return state;
}

function useMouse(target, options = {}) {
	const { fps = 30, enterDelay = 0, leaveDelay = 0 } = options;
	const [state, dispatch] = React.useReducer(_ref2, {
		mouse: initialState,
		context: initialContext
	});
	const onMove = (0, _throttle.useThrottleCallback)(
		(event) => {
			const element = target && 'current' in target ? target.current : target;
			if (!element) return;

			dispatch({
				type: 'mousemove',
				event,
				element
			});
		},
		fps,
		true
	);
	const onTouchMove = (0, _throttle.useThrottleCallback)(
		(event) => {
			const element = target && 'current' in target ? target.current : target;
			if (!element) return;
			dispatch({
				type: 'touchmove',
				event,
				element
			});
		},
		fps,
		true
	);
	const onLeave = (0, _throttle.useThrottleCallback)(
		() =>
			dispatch({
				type: 'mouseleave'
			}),
		fps, // This has to be false because we always want this callback to fire after any
		// move events.
		false
	);
	const onDown = (0, _throttle.useThrottleCallback)(
		(event) => {
			const element = target && 'current' in target ? target.current : target;
			if (!element) return;
			dispatch(
				'touches' in event
					? {
						type: 'touchdown',
						element,
						event
					  }
					: {
						type: 'mousedown',
						element,
						event
					  }
			);
		},
		fps,
		true
	);
	const onUp = (0, _throttle.useThrottleCallback)(
		() =>
			dispatch({
				type: 'mouseup'
			}),
		fps, // This has to be false because we always want this callback to fire after any
		// down events.
		false
	);
	const onTouchEnd = (0, _throttle.useThrottleCallback)(
		() =>
			dispatch({
				type: 'touchleave'
			}),
		fps, // This has to be false because we always want this callback to fire after any
		// move events.
		false
	);
	(0, _event.default)(target, 'mouseenter', onMove);
	(0, _event.default)(target, 'mousemove', onMove);
	(0, _event.default)(target, 'mouseleave', onLeave);
	(0, _event.default)(target, 'mousedown', onDown);
	(0, _event.default)(window, 'mousedown', onDown);
	(0, _event.default)(window, 'mouseup', onUp);
	(0, _event.default)(target, 'touchstart', onDown);
	(0, _event.default)(target, 'touchmove', onTouchMove);
	(0, _event.default)(target, 'touchend', onTouchEnd);
	(0, _event.default)(target, 'touchcancel', onTouchEnd);

	function _ref3() {
		return dispatch({
			type: 'activeStatus',
			value: 'active'
		});
	}

	function _ref4() {
		return dispatch({
			type: 'activeStatus',
			value: 'inactive'
		});
	}

	React.useEffect(() => {
		if (state.context.hoverStatus === 'enter') {
			if (enterDelay) {
				const timeout = setTimeout(_ref3, enterDelay);
				return () => clearTimeout(timeout);
			}

			dispatch({
				type: 'activeStatus',
				value: 'active'
			});
		}
		else {
			if (leaveDelay) {
				const timeout = setTimeout(_ref4, leaveDelay);
				return () => clearTimeout(timeout);
			}

			dispatch({
				type: 'activeStatus',
				value: 'inactive'
			});
		}
	}, [state.context.hoverStatus, enterDelay, leaveDelay]);
	return state.context.activeStatus === 'active' ? state.mouse : initialState;
}

const initialState = {
	x: null,
	y: null,
	pageX: null,
	pageY: null,
	clientX: null,
	clientY: null,
	screenX: null,
	screenY: null,
	elementWidth: null,
	elementHeight: null,
	isOver: false,
	isDown: false,
	isTouch: false
};
const initialContext = {
	hoverStatus: 'idle',
	touchStatus: 'idle',
	activeStatus: 'inactive'
};
let _default = useMouse;
exports.default = _default;
